import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader, DataTable, Section, Loading, EmptyState } from "../components/Common";
import { FileText } from "lucide-react";

export default function Documents() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.documents().then(({ data }) => setItems(data)); }, []);
  if (items === null) return <Loading />;
  return (
    <div data-testid="documents-page">
      <PageHeader kicker="Document Management" title="Documents & Certificates" subtitle="Generated letters, transcripts, certificates and policies." />
      <Section>
        {items.length === 0 ? (
          <EmptyState icon={FileText} title="No documents yet" body="Documents generated through the Education360 reporting engine will appear here." />
        ) : (
          <DataTable
            columns={[
              { key: "title", label: "Title" },
              { key: "category", label: "Category" },
              { key: "generated_by_ai", label: "AI", render: (r) => r.generated_by_ai ? "Yes" : "No" },
              { key: "created_at", label: "Created", render: (r) => (r.created_at || "").slice(0, 10) },
            ]}
            rows={items}
          />
        )}
      </Section>
    </div>
  );
}
